import { render, staticRenderFns } from "./FinishTestConfirm.vue?vue&type=template&id=312314be&scoped=true&"
import script from "./FinishTestConfirm.vue?vue&type=script&lang=js&"
export * from "./FinishTestConfirm.vue?vue&type=script&lang=js&"
import style0 from "./FinishTestConfirm.vue?vue&type=style&index=0&id=312314be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312314be",
  null
  
)

export default component.exports